import React, { Component } from "react";

/**
 * Floating "Get a Quote" pill that fades in after the user scrolls 400px.
 *
 * Hidden on any page that already embeds the booking form (landing/section.js),
 * or where the CTA would send users away from something they're already doing.
 *
 * Shown on: location pages, blog, articles, content guides, pricing, about, etc.
 * Hidden on: all service hub pages (any page with the inline booking form).
 */
const HIDE_EXACT = new Set([
  "/", "/v2", "/quote", "/book", "/book-a-truck", "/instant-quote",
  "/get-quote", "/landing-3", "/chat", "/partner-drivers",
  "/track-order", "/register-your-vehicle",
]);

// Any path starting with these prefixes has the booking form embedded
const HIDE_PREFIXES = [
  "/bakkie-hire", "/truck-hire", "/van-hire", "/furniture-delivery",
  "/furniture-removals", "/moving-companies", "/same-day-courier",
  "/courier-services", "/1-ton-truck-hire", "/4-ton-truck-hire",
  "/8-ton-truck-hire", "/flatbed-truck-hire", "/tipper-truck-hire",
  "/refrigerated-truck-hire", "/bakkie-hire-near-me", "/truck-hire-near-me",
  "/office-removals", "/appliance-delivery", "/house-moves",
  "/last-mile-delivery", "/piano-moving", "/mattress-delivery",
  "/student-moves", "/construction-material-delivery", "/regular-deliveries",
  "/customer-truck-hire",
];

class FloatingQuoteCTA extends Component {
  constructor(props) {
    super(props);
    this.state = { visible: false };
  }

  componentDidMount() {
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    this.setState({ visible: window.scrollY > 400 });
  };

  render() {
    const path = window.location.pathname;
    if (HIDE_EXACT.has(path)) return null;
    if (HIDE_PREFIXES.some((p) => path === p || path.startsWith(p + "/") || path.startsWith(p + "?") || path.startsWith(p + "-"))) return null;

    return (
      <a
        href="/quote"
        className={`floating-quote-cta${this.state.visible ? " floating-quote-cta--visible" : ""}`}
        aria-label="Get an instant quote"
      >
        <i className="mdi mdi-truck-fast floating-quote-icon" />
        <span>Get a Quote</span>
      </a>
    );
  }
}

export default FloatingQuoteCTA;
